import React, { useEffect, useRef } from "react";
import confetti from "canvas-confetti";

export default function Confetti() {
	const canvasRef = useRef(null);
	
	useEffect(() => {
		const emoji = confetti.shapeFromText({text: '🍔', scalar: 2})
		
		const myConfetti = confetti.create(canvasRef.current, {
			resize: true,
			useWorker: true,
		});
		
		myConfetti({
			particleCount: 100,
			spread: 70,
			origin: { y: 1.2 },
			ticks: 150,
			gravity: 0,
			decay: 0.96,
			scalar: 2,
			startVelocity: 20,
			shapes: [emoji]
		});
		
	}, []);
	
	return (
		<canvas
			ref={canvasRef}
			style={{
				position: "fixed",
				pointerEvents: "none",
				width: "100%",
				height: "100%",
				top: 0,
				left: 0,
				zIndex: 9999,
			}}
		/>
	);
}
